import { render, staticRenderFns } from "./CounterTwo.vue?vue&type=template&id=188bf9e8"
import script from "./CounterTwo.vue?vue&type=script&lang=js"
export * from "./CounterTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports